// extracted by mini-css-extract-plugin
export var body = "_1w-8";
export var button = "_1w-0";
export var closeButton = "_1w-5";
export var content = "_1w-3";
export var empty = "_1w-f";
export var grid = "_1w-c";
export var header = "_1w-4";
export var icon = "_1w-1";
export var option = "_1w-d";
export var optionSelected = "_1w-e";
export var overlay = "_1w-2";
export var searchIcon = "_1w-a";
export var searchInput = "_1w-b";
export var searchWrapper = "_1w-9";
export var title = "_1w-6";
export var visuallyHidden = "_1w-7";